module.exports = __webpack_public_path__ + "59fb7a6cf129f70953ea9a3b5fa04d5f.pdf";